import logo from '../assets/logo.svg';

const Footer = () => {
  return (
    <section className="flex flex-col md:pb-[6rem] sm:pb-[5rem] pb-[5rem] lg:pb-[80px] md:pt-[6rem] sm:pt-[5rem] pt-[5rem] lg:pt-[80px] xl:w-[100%] xl:max-w-[auto] w-[100%] max-w-[auto] ml-[auto] mr-[auto]">
      <div className="flex flex-col w-[100%] max-w-[1280px] mr-[auto] ml-[auto] md:pr-[4rem] sm:pr-[4rem] pr-[1.5rem] lg:pr-[32px] md:pl-[4rem] sm:pl-[4rem] pl-[1.5rem] lg:pl-[32px] sm:gap-[3rem] gap-[2rem] md:gap-[4rem] items-center sm:items-start 2xl:max-w-[1536px]">
        <img src={logo} className="h-[auto] max-w-[100%] w-[100%]" alt="Omega Post Logo" />
        <span className="text-[16px] block">© 2026. Wszelkie prawa zastrzeżone.</span>
      </div>
    </section>
  );
};

export default Footer;
